import { IconProps } from "./types";
import { Theme } from "../../styles";
import icons from "../../assets/icons";
import { useTheme } from "styled-components";

const Icon = ({ iconName, width, height, fill, className }: IconProps) => {
  const { colors } = useTheme() as Theme;

  const IconComponent = icons[iconName];

  if (!IconComponent) return null;

  return (
    <IconComponent
      style={{ transition: ".5s ease" }}
      fill={fill ?? colors.accent}
      width={width}
      height={height}
      className={className}
    />
  );
};

export default Icon;
